export function runModWorker(url, payload, {progress = () => {}, signal, type = 'module'} = {}) {
    return new Promise((resolve, reject) => {
        let worker;
        const finish = (error, value) => {
            worker?.terminate();
            signal?.removeEventListener('abort', abort);
            error ? reject(error) : resolve(value);
        };
        const abort = () => finish(new DOMException('Mod work cancelled', 'AbortError'));
        if (signal?.aborted) return abort();
        try {
            worker = new Worker(url, {type});
            signal?.addEventListener('abort', abort, {once: true});
            worker.onmessage = ({data}) => {
                if (data.error) finish(new Error(data.error));
                else if (data.result !== undefined) finish(null, data.result);
                else if (data.progress !== undefined) progress(data.progress);
            };
            worker.onerror = event => { event.preventDefault(); finish(new Error(event.message || 'Mod worker unavailable')); };
            worker.onmessageerror = () => finish(new Error('Could not read mod worker result'));
            worker.postMessage(payload);
        } catch (error) { finish(error); }
    });
}

export async function extractModZip(blob, progress) {
    try {
        return await runModWorker(new URL('./modZipWorker.js', import.meta.url), blob, {progress, type: 'classic'});
    } catch {
        // Older or restricted browsers still support the existing editor path.
        const {extractModFiles} = await import('./modImport.js');
        const zip = await globalThis.JSZip.loadAsync(blob);
        return extractModFiles(zip.files, (done, total) => progress?.(done / total));
    }
}
